import styled from "styled-components";

export const PaymentContainer = styled.div`
display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const PaymentSelectorWrapper = styled.div`
    flex-grow: 1;
`;

export const PaymentSelector = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 600px;
    margin: 8px auto;
    padding: 0 15px;
    border-radius: 8px;
    border: 1px solid #e3e1e1;
    grid-gap: 10px;
    gap: 10px;
    cursor: pointer;
    background-color: #fff;
    min-height: 60px;
`;

export const GooglePaymentSelector = styled(PaymentSelector)`
        padding-left: 15px;
        padding-right: 3px;
`;

export const ApplePaymentSelector = styled(PaymentSelector)`
        padding-left: 15px;
        padding-right: 8px;
`;

export const PaymentCheckboxWrapper = styled.div`
    display: flex;
`;

export const PaymentCheckbox = styled.input`
  margin-right: 25px;
  width: 1em;
  height: 1em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  &:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23FF3333'/%3e%3c/svg%3e");
    border-color: rgb(135, 135, 134);
  }
`;

export const PaymentSelectorTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #333030;
`;

export const PaymentSelectorIcon = styled.img``;

export const PaymentGoogleIcon = styled(PaymentSelectorIcon)`
    width: 65px;
`;

export const PaymentCardTypeWrapper = styled.div`
    font-size: 12px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
`;

interface WalletWrapperProps {
    visible: boolean;
}

export const WalletWrapper = styled.div<WalletWrapperProps>`
    margin-bottom: 20px;
    visibility: ${(props) => (props.visible ? "visible" : "hidden")};
`;